import * as React from 'react';
import './Footer.css';
import MediaQuery from 'react-responsive';
import { MOBILE_MAX_WIDTH, TABLET_MAX_WIDTH } from '../../utils';
import MobileFooter from './MobileFooter/MobileFooter';
import Link from '@material-ui/core/Link';
import { useLocation } from 'react-router-dom';

const Footer: React.FunctionComponent = props => {
	const location = useLocation();

	return <div className="footer">
		<MediaQuery minWidth={TABLET_MAX_WIDTH}>
			<div className="footer__wrapper">
				2020. Readed.me - <Link href="mailto:independ12@gmail.com">написать нам</Link> | <Link target='_blank' href="https://api.readed.me/documents/privacy.html">Политика конфиденциальности</Link>
			</div>
		</MediaQuery>
		
		<MediaQuery maxWidth={TABLET_MAX_WIDTH}>
			<MobileFooter />
		</MediaQuery>
	</div>;
};

export default Footer;
